import { Skeleton } from '@atom/mui';

import classes from './skeletonRow.module.css';

const SkeletonListRow = () => (
  <div className={classes.skeletonListRow}>
    <div className={classes.skeletonListBullet}>
      <Skeleton variant="circular" />
    </div>
    <div className={classes.skeletonListItem}>
      <Skeleton />
    </div>
  </div>
);

export default SkeletonListRow;
